// extracted by mini-css-extract-plugin
module.exports = {"label":"Checkbox__label__RDrWr","checkbox":"Checkbox__checkbox__14U1-","input":"Checkbox__input__2Adv5","caption":"Checkbox__caption__2iVOs"};